import { AxiosInstance } from 'axios';
import * as ForecastByRoomTypeReportService from './services';

export type ForecastByRoomTypeReportServiceType = {
  exportPDF: ReturnType<typeof ForecastByRoomTypeReportService.exportPDF>;
  getSettingsColumns: ReturnType<typeof ForecastByRoomTypeReportService.getSettingsColumns>;
};

export const initForecastByRoomTypeReportService = (
  axios: AxiosInstance
): ForecastByRoomTypeReportServiceType => ({
  exportPDF: ForecastByRoomTypeReportService.exportPDF(axios),
  getSettingsColumns: ForecastByRoomTypeReportService.getSettingsColumns(axios),
});
